import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnChanges, OnInit} from '@angular/core';
import {customRandom, random, urlAlphabet} from 'nanoid';
import {TypedSimpleChanges} from '../../../../../common/typed-on-changes';
import {sparkline, SparklineResult} from './sparkline';

@Component({
    selector:        'sparkline',
    templateUrl:     './sparkline.component.html',
    styleUrls:       ['./sparkline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false
})
export class SparklineComponent implements OnInit, OnChanges {

    @Input()
    public width: number;

    @Input()
    public height: number;

    @Input()
    public strokeWidth: number;

    @Input()
    public data: number[];

    @Input()
    public tick: number;

    @Input()
    public gradientOpacity: number = 1;

    public readonly id = customRandom(urlAlphabet, 10, random)();

    public sparklineResult: SparklineResult;

    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public ngOnChanges(changes: TypedSimpleChanges<SparklineComponent>): void {
        if (changes.data && !changes.data.firstChange || changes.tick && !changes.tick.firstChange) {
            this.updateChart(!!changes.data);
        }
    }

    public ngOnInit(): void {
        this.updateChart(true);
    }

    private updateChart(isDataChanged: boolean): void {
        this.sparklineResult = sparkline(
            this.data || [],
            this.tick,
            {
                width:       this.width,
                height:      this.height,
                strokeWidth: this.strokeWidth
            },
            isDataChanged ? undefined : this.sparklineResult
        );

        this.changeDetectorRef.detectChanges();
    }

}
